import { takeEvery } from 'redux-saga/effects';
import { TRACK } from '../consts';
import { TrackAction } from '../types';
import decorateAnalytics from '../utils/decorateAnalytics';
import isGAReady from '../utils/isGAReady';
import { GTM } from '../../clients';
import { buildGlobalDecorators } from './utils';

export function* onTrack({
  payload: {
    event,
    category = 'All',
    label,
    value: providedValue,
    properties = {},
    decorators = {},
  },
}: TrackAction) {
  const decoratorData = yield* buildGlobalDecorators(decorators);

  // GA events always need to be an int.
  let value;
  if (providedValue) {
    value = Math.round(providedValue);
    if (!value) {
      value = undefined;
    }
  }

  //
  // Send all events to GTM.
  GTM.legacy({
    event,
    properties: {
      category,
      label,
      value,
      ...decorateAnalytics(decoratorData, 'gtm'),
      ...properties,
    },
  });

  if (isGAReady()) {
    // Note: We need to strip out any props that don't fit GA's custom prop format.
    const params = {
      eventAction: event,
      eventLabel: label,
      eventCategory: category,
      eventValue: value,
      ...decorateAnalytics(decoratorData, 'ga'),
      ...properties,
    };

    window.ga('send', {
      hitType: 'event',
      ...params,
    });
  }
}

export default function* trackSaga() {
  yield takeEvery(TRACK, onTrack);
}
